function normalizeSearchTermForShopify(rawTerm) {
  const term = String(rawTerm || '').trim();
  const compact = term.replace(/\s+/g, '');

  // Shopify sí acepta estos campos en Storefront Search, pero no los consulta
  // cuando el comprador escribe solo el valor. El EAN/UPC se mantiene visible;
  // el operador se envía en un input oculto únicamente al hacer submit.
  if (/^\d{8,14}$/.test(compact)) return `variants.barcode:${compact}`;
  if (/^(?:GM|MU)[A-Z]?\d{5,}$/i.test(compact)) return `variants.sku:${compact}`;
  return term;
}

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.prepareSearchRequest.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  prepareSearchRequest() {
    const requestTerm = normalizeSearchTermForShopify(this.input.value);
    if (requestTerm === this.input.value.trim()) return;

    let requestInput = this.input.form.querySelector('input[data-search-request-term]');
    if (!requestInput) {
      requestInput = document.createElement('input');
      requestInput.type = 'hidden';
      requestInput.name = 'q';
      requestInput.dataset.searchRequestTerm = '';
      this.input.form.appendChild(requestInput);
    }
    requestInput.value = requestTerm;
    const inputName = this.input.getAttribute('name');
    this.input.removeAttribute('name');
    // Si otro componente cancela el submit (por ejemplo, al elegir una opción
    // del autocompletado), el formulario debe quedar reutilizable.
    setTimeout(() => {
      if (inputName) this.input.setAttribute('name', inputName);
      requestInput.remove();
    }, 0);
  }

  toggleResetButton() {
    if (!this.resetButton) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

if (typeof module !== 'undefined') module.exports = { SearchForm, normalizeSearchTermForShopify };
